var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-wrapper d-flex align-center justify-center"},[_c('v-icon',{attrs:{"color":"grey lighten-2"}},[_vm._v(" mdi-clipboard-text ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }